// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__dMWQL","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1fbIk"};